<template>
 <div class="bump">
      
    <v-data-table
      :headers="marketMaker"
      :items="time"
      hide-actions
      class="elevation-6"
      item-key="name"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.one }}</td>
        <td class="text-xs-right">{{ props.item.two }}</td>
        <td class="text-xs-right">{{ props.item.three }}</td>
        <td class="text-xs-right">{{ props.item.four }}</td>
        <td class="text-xs-right">{{ props.item.five }}</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text>{{ props.item.notes }}</v-card-text>
        </v-card>
      </template>
    </v-data-table>
      <br>
      <v-data-table
      :headers="transaction"
      :items="timetr"
      hide-actions
      class="elevation-6"
      item-key="name"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.one }}</td>
        <td class="text-xs-right">{{ props.item.two }}</td>
        <td class="text-xs-right">{{ props.item.three }}</td>
        <td class="text-xs-right">{{ props.item.four }}</td>
        <td class="text-xs-right">{{ props.item.five }}</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text>{{ props.item.notes }}</v-card-text>
        </v-card>
      </template>
    </v-data-table>
      <br>
      <v-data-table
      :headers="ads"
      :items="timead"
      hide-actions
      class="elevation-6"
      item-key="name"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.one }}</td>
        <td class="text-xs-right">{{ props.item.two }}</td>
        <td class="text-xs-right">{{ props.item.three }}</td>
        <td class="text-xs-right">{{ props.item.four }}</td>
        <td class="text-xs-right">{{ props.item.five }}</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text>{{ props.item.notes }}</v-card-text>
        </v-card>
      </template>
    </v-data-table>
      <br>
      <v-data-table
      :headers="onboard"
      :items="timeon"
      hide-actions
      class="elevation-6"
      item-key="name"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.one }}</td>
        <td class="text-xs-right">{{ props.item.two }}</td>
        <td class="text-xs-right">{{ props.item.three }}</td>
        <td class="text-xs-right">{{ props.item.four }}</td>
        <td class="text-xs-right">{{ props.item.five }}</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text>{{ props.item.notes }}</v-card-text>
        </v-card>
      </template>
    </v-data-table>
      <br>
    <v-data-table
      :headers="total"
      :items="totals"
      hide-actions
      class="elevation-6 total-table"
      item-key="name"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.one }}</td>
        <td class="text-xs-right">{{ props.item.two }}</td>
        <td class="text-xs-right">{{ props.item.three }}</td>
        <td class="text-xs-right">{{ props.item.four }}</td>
        <td class="text-xs-right">{{ props.item.five }}</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text>{{ props.item.notes }}</v-card-text>
        </v-card>
      </template>
    </v-data-table>
      <br>
</div>
</template>

<script>
export default {
  data() {
    return {
      marketMaker: [
        {
          text: 'Market Maker Fee',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Year 1', value: 'one', sortable: false, align: 'right' },
        { text: 'Year 2', value: 'two', sortable: false, align: 'right' },
        { text: 'Year 3', value: 'three', sortable: false, align: 'right' },
        { text: 'Year 4', value: 'four', sortable: false, align: 'right' },
        { text: 'Year 5', value: 'five', sortable: false, align: 'right' }
      ],
      transaction: [
        {
          text: 'Transaction Fee',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Year 1', value: 'one', sortable: false, align: 'right' },
        { text: 'Year 2', value: 'two', sortable: false, align: 'right' },
        { text: 'Year 3', value: 'three', sortable: false, align: 'right' },
        { text: 'Year 4', value: 'four', sortable: false, align: 'right' },
        { text: 'Year 5', value: 'five', sortable: false, align: 'right' }
      ],
      ads: [
        {
          text: 'Advertising Revenue',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Year 1', value: 'one', sortable: false, align: 'right' },
        { text: 'Year 2', value: 'two', sortable: false, align: 'right' },
        { text: 'Year 3', value: 'three', sortable: false, align: 'right' },
        { text: 'Year 4', value: 'four', sortable: false, align: 'right' },
        { text: 'Year 5', value: 'five', sortable: false, align: 'right' }
      ],
      onboard: [
        {
          text: 'Onboarding/Training Fee',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Year 1', value: 'one', sortable: false, align: 'right' },
        { text: 'Year 2', value: 'two', sortable: false, align: 'right' },
        { text: 'Year 3', value: 'three', sortable: false, align: 'right' },
        { text: 'Year 4', value: 'four', sortable: false, align: 'right' },
        { text: 'Year 5', value: 'five', sortable: false, align: 'right' }
      ],
      total: [
        {
          text: 'Total Pawtocol Revenue',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Year 1', value: 'one', sortable: false, align: 'right' },
        { text: 'Year 2', value: 'two', sortable: false, align: 'right' },
        { text: 'Year 3', value: 'three', sortable: false, align: 'right' },
        { text: 'Year 4', value: 'four', sortable: false, align: 'right' },
        { text: 'Year 5', value: 'five', sortable: false, align: 'right' }
      ],//End Headers
      time: [
        {
          value: false,
          name: 'Total Capturable Pet Market',
          notes: '94 million cats and 90 million dogs in the US\n62 million dogs and 53 million cats in China\n15 million dogs and 13 million cats in Russia\n36 million dogs and 13 million cats in Brazil\n12 million dogs and 7 million cats in Japan\n8 million dogs and 9 million cats in Canada\nFor a total of 412 million dogs and cats in our initial target markets\nWe then reduce the initial target market (412 million) to account for those who may not be willing to engage with new technology products:\n7.9% to account for the global population of those 65 years of age and older\n19% to account for those under the age of 10\nAn additional, 15% of those aged 10-65 to account for those who do not own a smartphone\nBringing us to a conservative addressable market size of 256 million dogs and cats\n* Pet population has been growing at 10%',
          one: '256,000,000',
          two: '281,600,000',
          three: '309,760,000',
          four: '340,736,000',
          five: '374,809,600'
        },
        {
          value: false,
          name: 'Pawtocol Capture Rate On Platform',
          notes: 'Based on conservative estimates',
          one: '0%',
          two: '0.25%',
          three: '1.00%',
          four: '2.00%',
          five: '3.50%'
        },
        {
          value: false,
          name: 'Pets on Pawtocol Platform',
          notes: 'Calculated from capture rates',
          one: '0',
          two: '704,000',
          three: '3,097,600',
          four: '6,814,720',
          five: '13,118,336'
        },
        {
          value: false,
          name: 'Average Transactions Per Pet/Yr',
          notes: 'Examples of data sets include:\nData gathered via push-notifications\n- age, breed, name, weight, height.\nData gathered via IoT devices\n- heart rate, walking distances, food intake\nData gathered via medical devices\n- blood results, stool results.',
          one: '20',
          two: '22',
          three: '24',
          four: '27',
          five: '29'
        },
        {
          value: false,
          name: 'Average Value Per Data Transaction',
          notes: 'Datacoup paid consumers $8/month or $96/year\nto access their transaction data and social media account data.\nTechcrunch, quotes the value of a name at 30 cents.',
          one: '$2.5',
          two: '$3',
          three: '$3',
          four: '$3',
          five: '$3'
        },
        {
          value: false,
          name: 'Pawtocol Market Maker %',
          notes: 'Charge 1% to each party. Just like a bid/ask spread with a traditional market maker.',
          one: '2%',
          two: '2%',
          three: '2%',
          four: '2%',
          five: '2%'
        },
        {
          value: false,
          name: '',
          expand: false,
          one: '$0',
          two: '$797,632',
          three: '$3,976,355',
          four: '$9,911,463',
          five: '$21,617,148'
        }
      ],
      //Transaction Fee Revenue
      timetr: [
        {
          value: false,
          name: 'Pet owners within capturable market',
          notes: '223 million dogs and 189 cats in our initial target markets\n189/2.1(avg. cats per household) = 90 million cat owners\n223/1.6(avg. dogs per household) = 140 million dog owners\nBringing us to 230 million owners\n',
          one: '168,000,000',
          two: '177,240,000',
          three: '186,988,200',
          four: '197,272,551',
          five: '208,122,541'
        },
        {
          value: false,
          name: 'Pawtocol Capture Rate On Platform',
          notes: 'Based on conservative estimates',
          one: '0%',
          two: '0.25%',
          three: '1.00%',
          four: '2.00%',
          five: '3.50%'
        },
        {
          value: false,
          name: 'Pet Owners on Pawtocol Platform',
          notes: 'Calculated from capture rates',
          one: '0',
          two: '443,100',
          three: '1,869,882',
          four: '3,945,451',
          five: '7,284,289'
        },
        {
          value: false,
          name: 'Pet Owners Willing to Participate in Loyalty Points Systems',
          notes: '80% of americans belong to a loyalty points system \nReduce by 20% to account for those unwilling to participate.\nhttps://www.reuters.com/brandfeatures/synchrony/inside-retail/much-love-for-loyalty-programs',
          one: '0',
          two: '354,480',
          three: '1,495,906',
          four: '3,156,361',
          five: '5,827,431'
        },
        {
          value: false,
          name: 'Average US Yearly Pet Expenditure',
          notes: 'https://www.bls.gov/opub/ted/2017/households-spent-an-average-of-528-dollars-on-pets-in-2015.htm',
          one: '$612',
          two: '$642',
          three: '$673',
          four: '$706',
          five: '$741'
        },
        {
          value: false,
          name: 'Maximum Value of Goods and Services Transacted on Network',
          notes: '',
          one: '$0',
          two: '$227,493,797',
          three: '$1,007,064,991',
          four: '$2,229,027,580',
          five: '$4,316,993,935'
        },
        {
          value: false,
          name: 'Pawtocol Transaction Fee',
          notes: 'Far less than Amex, Visa, or MasterCard',
          one: '0.5%',
          two: '0.5%',
          three: '0.5%',
          four: '0.5%',
          five: '0.5%'
        },
        {
          value: false,
          name: '',
          expand: false,
          one: '$0',
          two: '$1,137,469',
          three: '$5,035,325',
          four: '$11,145,138',
          five: '$21,584,970'
        }
      ],
      //Advertising Revenue
      timead: [
        {
          value: false,
          name: 'Target Cat and Dog Population Annual Spend',
          notes: '223 million dogs and 189 cats in our initial target markets\n189/2.1(avg. cats per household) = 90 million cat owners\n223/1.6(avg. dogs per household) = 140 million dog owners\nBringing us to 230 million owners\n',
          one: '$102,780,710,587',
          two: '$107,816,965,406',
          three: '$113,099,996,711',
          four: '$118,641,896,549',
          five: '$124,455,349,480'
        },
        {
          value: false,
          name: 'Digital Media Advertising Spend (Pet Industry) as a Percent of Industry Revenue',
          notes: 'Use PetSmart to determine industry average Revenue/Digital Media Ad Spend\n2015 PetSmart Revenue = $7B\n2015 PetSmart Media Ad Spend = $105 M\n105M/7B = 1.5%',
          one: '1.50%',
          two: '1.50%',
          three: '1.50%',
          four: '1.50%',
          five: '1.50%'
        },
        {
          value: false,
          name: 'Total Capturable Digital Advertising Market',
          notes: '',
          one: '$1,541,710,659',
          two: '$1,617,254,481',
          three: '$1,696,499,951',
          four: '$1,779,628,448',
          five: '$1,866,830,242'
        },
        {
          value: false,
          name: 'Pawtocol % Capture of Advertising Market',
          notes: '',
          one: '0.01%',
          two: '0.25%',
          three: '1.00%',
          four: '1.50%',
          five: '2.00%'
        },
        {
          value: false,
          name: '',
          expand: false,
          one: '$154,171',
          two: '$4,043,136',
          three: '$16,965,000',
          four: '$26,694,427',
          five: '$37,336,605'
        }
      ],
      //Onboarding Revenue
      timeon: [
        {
          value: false,
          name: 'Price Per Day to Onboard',
          notes: '223 million dogs and 189 cats in our initial target markets\n189/2.1(avg. cats per household) = 90 million cat owners\n223/1.6(avg. dogs per household) = 140 million dog owners\nBringing us to 230 million owners\n',
          one: '$10,000',
          two: '$10,300',
          three: '$10,609',
          four: '$118,641,896,549',
          five: '$124,455,349,480'
        },
        {
          value: false,
          name: 'Digital Media Advertising Spend (Pet Industry) as a Percent of Industry Revenue',
          notes: 'Use PetSmart to determine industry average Revenue/Digital Media Ad Spend\n2015 PetSmart Revenue = $7B\n2015 PetSmart Media Ad Spend = $105 M\n105M/7B = 1.5%',
          one: '1.50%',
          two: '1.50%',
          three: '1.50%',
          four: '1.50%',
          five: '1.50%'
        },
        {
          value: false,
          name: 'Total Capturable Digital Advertising Market',
          notes: '',
          one: '$1,541,710,659',
          two: '$1,617,254,481',
          three: '$1,696,499,951',
          four: '$1,779,628,448',
          five: '$1,866,830,242'
        },
        {
          value: false,
          name: 'Pawtocol % Capture of Advertising Market',
          notes: '',
          one: '0.01%',
          two: '0.25%',
          three: '1.00%',
          four: '1.50%',
          five: '2.00%'
        },
        {
          value: false,
          name: '',
          expand: false,
          one: '$154,171',
          two: '$4,043,136',
          three: '$16,965,000',
          four: '$26,694,427',
          five: '$37,336,605'
        }
      ],
      //Totals Revenue
      totals: [
        {
          value: false,
          name: '',
          one: '$154,171',
          two: '$7,780,737',
          three: '$29,955,055',
          four: '$57,312,388',
          five: '$97,421,354'
        }
      ]
    }
  }
}    
</script>

<style>
  
</style>